import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import noop from '../../../../../utils/noop';
import TextButton from '../../../../../Buttons/TextButton';
import ShareIcon from '../../../../../Icons/24x24/Share';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiEventType, BiDataHook } from '@wix/da-bi/pkg/constants';
import PopperManager from '../../../../../Popover/PopperManager';
import Popper from '../../../../../Popover/Popper';
import DesktopSharePopup from '../../../../../SharePopup/DesktopSharePopup/DesktopDeviationSharePopup';
import { usePopoverOnInteraction } from '../../../../../Popover/PopoverOnInteraction/usePopoverOnInteraction';
import { getDeviationResourceType } from '../../../../_helpers';
import overlayStyles from '../../../../Thumb/Standard/Overlay/_partials/OverlayIcons.scss';
import s from './ShareControl.scss';
var ShareControl = function (_a) {
    var deviation = _a.deviation, className = _a.className, iconClassName = _a.iconClassName, size = _a.size, _b = _a.showMobileSharePopup, showMobileSharePopup = _b === void 0 ? noop : _b;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _c = usePopoverOnInteraction({ listenOnClicks: true }), isVisible = _c.isVisible, popoverClick = _c.onClick, onClose = _c.onClose;
    var onClick = function () {
        if (isMobile) {
            showMobileSharePopup();
        }
        else {
            popoverClick();
        }
    };
    return (React.createElement(PopperManager, { renderReference: function (_a) {
            var ref = _a.ref;
            return (React.createElement(TextButton, { size: "medium", variant: "unbranded", className: classnames(overlayStyles['icon-button'], className), onClick: onClick, biData: {
                    evid: BiEventType.CLICK_SHARE,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                }, "data-hook": BiDataHook.DEVIATION_SHARE_BUTTON, "aria-label": t('deviationview.overlay.a11y.share'), style: { display: 'inline-block' }, innerRef: ref },
                React.createElement(ShareIcon, { size: size, withPadding: false, disableDefaultColors: true, className: classnames(overlayStyles['icon'], iconClassName) }),
                t('actionbar.share')));
        } }, isVisible && (React.createElement(Popper, { onClickOutside: onClose, disablePlacementModifier: true, showArrow: false, modifiers: {
            offset: {
                offset: '0, 8',
            },
        }, contentClassName: s['popover'], usePortal: true },
        React.createElement(DesktopSharePopup, { deviation: deviation })))));
};
ShareControl.displayName = 'ShareControl';
export default ShareControl;
//# sourceMappingURL=ShareControl.js.map